/**
 * Expense items use "price with DDV" (VAT included):
 * - total = line total with VAT (what's on the receipt)
 * - taxAmount = VAT amount for the line
 * - subtotal = total - taxAmount
 *
 * Legacy items (no taxAmount): total is subtotal, tax is %, derive taxAmount = total * tax/100
 */

/** Derive VAT amount when total includes VAT: taxAmount = total * taxPct / (100 + taxPct) */
export function deriveTaxAmountFromTotalWithVat(
  total: number,
  taxPct: number
): number {
  if (total <= 0 || taxPct <= 0) return 0;
  return Math.round(((total * taxPct) / (100 + taxPct)) * 100) / 100;
}

type ExpenseItemInput = {
  total: number;
  tax: number;
  taxAmount?: number | null;
};

export const calculateExpenseTotals = (items: ExpenseItemInput[]) => {
  let grandTotal = 0;
  let totalTax = 0;

  for (const item of items) {
    const lineTotal = Number(item.total);
    const taxPct = Number(item.tax);

    const lineTaxAmount =
      item.taxAmount != null && item.taxAmount > 0
        ? Number(item.taxAmount)
        : lineTotal * (taxPct / 100);

    // Legacy: total is subtotal, so line total with VAT = lineTotal + lineTaxAmount
    // New: total already includes VAT, so line total = lineTotal
    const isPriceWithVat = item.taxAmount != null && item.taxAmount > 0;

    grandTotal += isPriceWithVat ? lineTotal : lineTotal + lineTaxAmount;
    totalTax += lineTaxAmount;
  }

  return {
    subtotal: grandTotal - totalTax,
    tax: totalTax,
    total: grandTotal,
  };
};
